import { render, staticRenderFns } from "./new-home.vue?vue&type=template&id=220ec274&scoped=true"
import script from "./new-home.vue?vue&type=script&lang=js"
export * from "./new-home.vue?vue&type=script&lang=js"
import style0 from "./new-home.vue?vue&type=style&index=0&id=220ec274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ec274",
  null
  
)

export default component.exports